import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayouts = () => <Outlet />;

export default AuthLayouts;
